/**
 * Seção: ReferenciasInfo
 * Bloco de referências familiares (reutilizável)
 */

import React, { useState } from 'react';
import { FormFieldGroup } from '../components';
import { useFormValidation } from '../hooks';

export interface ReferenciaData {
  name: string;
  phone: string;
}

interface ReferenciasInfoProps {
  numero: 1 | 2;
  data: ReferenciaData;
  onChange: (newData: Partial<ReferenciaData>) => void;
}

export const ReferenciasInfo: React.FC<ReferenciasInfoProps> = ({
  numero,
  data,
  onChange,
}) => {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const { validatePhone, validateText } = useFormValidation();

  const handleNameChange = (value: string) => {
    onChange({ name: value });
    const validation = validateText(value, 3);
    if (!validation.valid) {
      setErrors((prev) => ({ ...prev, name: validation.error || '' }));
    } else {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.name;
        return newErrors;
      });
    }
  };

  const handlePhoneChange = (value: string) => {
    const cleaned = value.replace(/\D/g, '');
    const formatted = cleaned
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .slice(0, 15);

    onChange({ phone: formatted });
    const validation = validatePhone(formatted);
    if (!validation.valid) {
      setErrors((prev) => ({ ...prev, phone: validation.error || '' }));
    } else {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.phone;
        return newErrors;
      });
    }
  };

  return (
    <div className="referencias-info-section">
      <h4 className="referencias-heading">Referência {numero}</h4>

      <FormFieldGroup label="Nome" required error={errors.name}>
        <input
          type="text"
          placeholder="Nome completo"
          value={data.name}
          onChange={(e) => handleNameChange(e.target.value)}
          className="form-input"
        />
      </FormFieldGroup>

      <FormFieldGroup label="Telefone" required error={errors.phone}>
        <input
          type="tel"
          placeholder="(45) 98765-4321"
          value={data.phone}
          onChange={(e) => handlePhoneChange(e.target.value)}
          className="form-input"
          maxLength={15}
        />
      </FormFieldGroup>
    </div>
  );
};

export default ReferenciasInfo;
